import { collection, doc, setDoc, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from "./firebase";
import { COLLECTIONS } from "./collections";

class TestResultService {
  /**
   * Salva um ou mais resultados de testes.
   * Cria um documento para cada (aluno + evento) simulando o comportamento de avaliações.
   * 
   * @param {Array} payloads Array de objetos formatados contendo dados do teste
   * @param {string} idTenant ID do Tenant
   */
  async saveResults(idTenant, payloads) {
    if (!idTenant || !payloads || payloads.length === 0) return;

    try {
      const tenantRef = doc(db, 'tenants', idTenant);
      const testsCollection = collection(tenantRef, COLLECTIONS.TESTS);

      const promises = payloads.map(async (payload) => {
        // Usa o idMember (ou idMember) + idEvent como hash ID para evitar duplicatas por evento, 
        // ou gera um ID novo se preferir.
        const docId = `${payload.idMember}_${payload.idEvent}`;
        const testRef = doc(testsCollection, docId);

        // Prepara os dados. Define data de criação caso seja novo.
        const testData = {
          ...payload,
          updatedAt: Timestamp.now(),
          createdAt: payload.createdAt || Timestamp.now()
        };

        // Adiciona audit trail basico
        return setDoc(testRef, testData, { merge: true });
      });

      await Promise.all(promises);
      return true;
    } catch (error) {
      console.error('Erro ao salvar resultados de teste:', error);
      throw error;
    }
  }

  /**
   * Busca os resultados salvos de uma Atividade dentro de um Evento
   * 
   * @param {string} idTenant ID do Tenant
   * @param {string} idActivity ID da Atividade/Modalidade
   * @param {string} idEvent ID do Ciclo/Evento
   */
  async getResultsByActivity(idTenant, idActivity, idEvent) {
    if (!idTenant || !idActivity || !idEvent) return [];

    try {
      const tenantRef = doc(db, 'tenants', idTenant);
      const testsCollection = collection(tenantRef, COLLECTIONS.TESTS);
      
      const q = query(
        testsCollection,
        where('idActivity', '==', idActivity),
        where('idEvent', '==', idEvent)
      );

      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      return results;
    } catch (error) {
      console.error('Erro ao buscar testes por atividade/evento:', error);
      throw error;
    }
  }

  /**
   * Busca todos os resultados salvos de um Evento
   * 
   * @param {string} idTenant ID do Tenant
   * @param {string} idEvent ID do Ciclo/Evento
   */
  async getResultsByEvent(idTenant, idEvent) {
    if (!idTenant || !idEvent) return [];

    try {
      const tenantRef = doc(db, 'tenants', idTenant);
      const testsCollection = collection(tenantRef, COLLECTIONS.TESTS);
      
      const q = query(
        testsCollection,
        where('idEvent', '==', idEvent)
      );

      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      return results;
    } catch (error) {
      console.error('Erro ao buscar testes por evento:', error);
      throw error;
    }
  }
}

const testResultServiceInstance = new TestResultService();
export default testResultServiceInstance;
